module.exports = __webpack_public_path__ + "static/media/tacometro-medio.ac290098.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/contentassets/tacometro-medio.svg
// module id = 146
// module chunks = 0